// Display existing components together; never rewrite the persisted row fields.
export function vatAmount(params) {
  if (!params.data) return params.value;
  return params.colDef.vatComponentFields.reduce((total, field) => {
    const raw = params.data[field];
    const value = Number(String(raw ?? 0).replaceAll(',', ''));
    return total + value;
  }, 0);
}

export function applyVatAmount(column) {
  if (column.vatComponentFields) column.valueGetter = vatAmount;
  if (column.children) column.children.forEach(applyVatAmount);
}
